import { Box } from "@mui/material";
import React from "react";

export default function CenterScreen({ children, minHeight = "100vh", ...rest }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={minHeight}
      flexDirection="column"
      sx={{ padding: 2 }}
      overflow={"hidden"}
      {...rest}
    >
      {children}
    </Box>
  );
}
